var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-dropdown-item',{attrs:{"type":"text"},nativeOn:{"click":function($event){return _vm.handleRequestDownload.apply(null, arguments)}}},[_vm._v("\n    Скачать реестр\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }